import { render, staticRenderFns } from "./ProjectThumb.vue?vue&type=template&id=c5045d42"
import script from "./ProjectThumb.vue?vue&type=script&lang=js"
export * from "./ProjectThumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports